import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { PopupButton } from "react-calendly"

export const UncoverTruth = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <>
      <div className="pt-10 mt-16">
        <div className="container mx-auto w-[70%]">
          <p className="lg:text-4xl text-nowrap md:text-[16px] text-[13px] text-black font-semibold text-center">
            Uncover the Truth – Transparency & Clarity <br /> in Every Step
          </p>
          <div className="lg:my-4 my-2 w-full">
            <p className="text-center text-black lg:text-sm text-[7px]">
              At Visual Folio, we believe in honesty, transparency, and
              delivering real results. No hidden processes, no surprises just
              clear communication, expert execution, and a commitment to your
              success. Let’s bring your vision to life with trust and integrity!
            </p>
          </div>

          <div className="flex justify-center">
            {rootElement && (
              <PopupButton
                className="px-5 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-[7px] whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text="Start Hiring"
              />
            )}
          </div>
        </div>
        <div className="container mx-auto mt-10 pt-10">
          <p className="text-black font-semibold text-xs mx-3 lg:mx-0">
            Hire Our <span className="text-[#7B68EC]">Talent</span>
          </p>
          <p className="text-2xl font-semibold text-black mx-3 lg:mx-0">
            Ready to Start your <span className="text-[#7B68EC]">journey?</span>
          </p>
        </div>
        <div className="container mx-auto mt-10">
          {theme == "glassy" ? (
            <div>
              <StaticImage
                className="lg:mx-3 w-full lg:mx-0"
                src="./working.png"
                alt="resource"
                placeholder="blurred"
                layout="fullWidth"
              />
            </div>
          ) : theme === "light" ? (
            <div>
              <StaticImage
                className="lg:mx-3 w-full lg:mx-0"
                src="./working-light.png"
                alt="resource"
                placeholder="blurred"
              />
            </div>
          ) : theme === "dark" ? (
            <div>
              <StaticImage
                className="lg:mx-3 w-full lg:mx-0"
                src="./working-dark.png"
                alt="map"
                placeholder="blurred"
              />
            </div>
          ) : (
            <div>
              <StaticImage
                className="lg:mx-3 w-full lg:mx-0"
                src="./working.png"
                alt="map"
                placeholder="blurred"
              />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
